import { Container } from "react-bootstrap";
import "./abouts.css";
import {Link} from "react-router-dom"
import { useGSAP } from "@gsap/react";
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

const About = () => {

  const scrollConfig = {
          trigger: ".abouts-gsap",
          start: "top 80%",
          end: "top 40%",
          scrub: 1,
        }
      useGSAP(() => {
      const tl7 = gsap.timeline();
      tl7.from(".abouts-heading-gsap", {
        x: 100,
        opacity: 0,
        scrollTrigger:scrollConfig
      });
       tl7.from(".abouts-p-gsap", {
        y: -100,
        opacity: 0,
        scrollTrigger:scrollConfig
      });
        tl7.from(".about-button", {
        x: 100,
        opacity: 0,
        scrollTrigger : {
          trigger: ".about-button",
          start: "top 80%",
          end: "top 80%",
          scrub: 1,
        }
      });
    });

  return (
    <>
      <section className="about-section position-relative abouts-gsap">
        <div className="about-content py-5">
          <Container>
            <div className="col-md-12 col-lg-8">
            <div className="position-relative heading-container abouts-heading-gsap">
                       <h2 className="heading">
                        A<span className="heading-span">BOUTS</span>
                      </h2>
                      <div className="line"></div>
                    </div>
              <p className="slider-p abouts-p-gsap">
                Best Deal Electricals, an Original Equipment Manufacturer (OEM),
                is one of the fastest-growing companies in Power Control &
                Electrical Equipment such as UPS, Servo Voltage Stabilizers, LT
                Panels, and Cable Trays. We are committed to delivering
                innovative, high-quality, and energy-efficient solutions for
                homes, offices, data centers, and industrial applications across
                India. <br />
                Under the Make in India initiative, we aim for continued growth
                in manufacturing. All products are made in our state-of-the-art
                facility by a dedicated team of engineers. <br />
                We are also authorized suppliers of LT & HT Transformers, Wires,
                Cables, Professional Lighting, HT Panels, Solar Street Lights,
                Inverters, and UPS. <br />
                Our focus on manufacturing excellence and innovation has
                positioned us as a leading provider of power control solutions
                and ensured complete customer satisfaction.
              </p>

             <Link to="/abouts" className="text-dark " > <button className="button about-button">Read More »</button></Link>
            </div>
          </Container>
        </div>
        <div className="about-slide h-100 col-6">
        </div>
        
      </section>
    </>
  );
};
export default About;
